import { Spinner } from "@xola/ui-kit";
import React from "react";

export const ItemsSyncInProgressNotice = () => {
    return (
        <div>
            <p>Some background tasks must be completed before the Items table can be loaded.</p>
            <p>You may navigate away from this page and we will email you when the updated Items table is ready.</p>
            <div className="mt-2 flex items-center">
                <span className="mr-1 font-bold">Status:</span>
                <span>In Process</span>
                <Spinner className="ml-2" size="tiny" />
            </div>
        </div>
    );
};
